import React from "react";
import { motion } from "framer-motion";

export default function PageHero({ eyebrow, title, kicker, accent }) {
  const words = title.split(" ");
  return (
    <section className="relative pt-36 md:pt-44 pb-16 md:pb-24 overflow-hidden grain border-b border-hairline">
      {/* faint orb */}
      <div
        aria-hidden
        className="pointer-events-none absolute -top-40 left-1/2 -translate-x-1/2 w-[60rem] h-[60rem] rounded-full"
        style={{
          background:
            "radial-gradient(circle, rgba(255,255,255,0.05), transparent 60%)",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.7 }}
          className="flex items-center gap-3 mb-8"
        >
          <span className="text-[11px] tracking-[0.28em] uppercase text-muted-x font-mono-x">
            {eyebrow}
          </span>
          <span className="h-px w-16 bg-hairline-strong" />
        </motion.div>
        <h1 className="font-display text-5xl sm:text-6xl md:text-8xl lg:text-9xl font-bold tracking-[-0.045em] leading-[0.9] text-primary-x text-balance max-w-6xl">
          {words.map((w, i) => (
            <motion.span
              key={i}
              initial={{ y: 60, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              transition={{
                delay: 0.1 + i * 0.06,
                duration: 0.8,
                ease: [0.22, 1, 0.36, 1],
              }}
              className="inline-block mr-[0.18em]"
            >
              {accent && w === accent ? (
                <span className="italic font-medium bg-gradient-to-br from-primary-x via-secondary-x to-muted-x bg-clip-text text-transparent">
                  {w}
                </span>
              ) : (
                w
              )}
            </motion.span>
          ))}
        </h1>
        {kicker && (
          <motion.p
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.45, duration: 0.7 }}
            className="mt-10 text-lg md:text-xl text-secondary-x max-w-2xl leading-relaxed"
          >
            {kicker}
          </motion.p>
        )}
      </div>
    </section>
  );
}
